// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"providerModals_modalBody___rA8h","interactionsBody":"providerModals_interactionsBody__2cfrw"};